import React from "react";

import $ from "jquery";
import _ from "underscore";

/*
    required interface to use this mixin:

    function expressionPrefix() => string
 */
import Styles from './../StyleSheet';

import Select2 from "shared/react_components/Select2";

const StringCompareTerminalMixin = {
  _valueStyles: function() {
    return (
      _.extend(
        {},
        Styles.lastChild,
        { width: this.props.editable ? '260px' : 'auto' }
      )
    );
  },

  _relOpStyles: function() {
    return (
      _.extend(
        {},
        Styles.select,
        { width: this.props.editable ? '200px' : 'auto' },
        this.props.node.shouldDisplayValue() ? undefined : Styles.lastChild
      )
    );
  },

  _onRelOpChange: function(evt) {
    this.props.node.set({
      relop: evt.target.value,
      value: this.props.node.get('value')
    });
  },

  _onValueChange: function(evt) {
    this.props.node.set('value', evt.target.value);
  },

  _triggerValidation: function() {
    this.props.node.trigger('validate');
  },

  renderRelOp: function(config) {
    config = config || {};

    var options = [
      <option key="=" value="=">Equals</option>,
      <option key="!=" value="!=">Not equals</option>
    ];

    if (!config.hideContains) {
      options.push(<option key="contains" value="contains">Contains</option>);
    }

    if (!config.hidePresent) {
      options.push(<option key="present" value="present">Present</option>);
    }

    return (
      <select
        className="form-control string-compare-rel-op-terminal"
        style={this._relOpStyles()}
        value={this.props.node.get('relop')}
        onChange={this._onRelOpChange}
        disabled={!this.props.editable}
      >
        {options}
      </select>
    );
  },

  renderValue: function(selectValues = "", callback = undefined) {
    if (selectValues === "" || this.props.node.get('relop') === "contains") {
      return this.renderInput();
    } else {
      var valuesUrl;
      var values;
      const defaultValue = this.props.node.get("value");

      if (typeof (selectValues) === 'string') {
        valuesUrl = selectValues;
      } else {
        values = _.extend([], selectValues);
        if (defaultValue !== "" && !_.contains(values, defaultValue)) {
          values.push(defaultValue);
        }
      }

      // initialize the 'text' with the defaultValue since the dropdown value is also the friendly name in this case
      // this allows the ajax-based select2's to have the correct initial value in them on load
      this.props.node.set('text', defaultValue, { silent: true });

      if (this.props.node.shouldDisplayValue()) {
        if (this.props.editable) {
          return (
            <Select2
              uniqueNameField='value'
              friendlyNameField='text'
              node={this.props.node}
              url={valuesUrl}
              values={values}
              changeListener={callback}
              width={this._valueStyles().width}
              showIdFromNetwork={true}
            />
          );
        } else {
          return this._renderReadonlyValue(defaultValue);
        }
      }
    }
  },

  renderInput: function() {
    return (
      <div className="form-group" style={$.extend(this.props.node.shouldDisplayValue() ? {} : { display: 'none' }, { verticalAlign: 'middle' })}>
        <input
          className="form-control"
          value={this.props.node.get('value')}
          onChange={this._onValueChange}
          onBlur={this._triggerValidation}
          style={this._valueStyles()}
          disabled={!this.props.editable}
        />
      </div>
    );
  }
};

export default StringCompareTerminalMixin;
